import { useState } from "react";
import { motion } from "framer-motion";
import { aiChips, aiSteps } from "../../data/phase2Content";
import { people } from "../../data/demoContent";
import { AIChip } from "./AIChip";
import { AIHubContent } from "./AIHub";
import { AIRecommendationCard } from "./AIRecommendationCard";
import { AIControls } from "./AIControls";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-10% 0px" },
  transition: { duration: 0.55, delay },
});

export const AIStatic = ({ consent, setConsent }) => {
  const [run, setRun] = useState(0);
  return (
    <div key={run} className="mx-auto max-w-[640px] px-5 pb-24 pt-12" data-testid="ai-static">
      <p className="eyebrow">Sample scenario</p>
      <ol className="mt-5 space-y-4">
        {aiSteps.map((s, i) => (
          <motion.li key={s.id} {...reveal(i * 0.15)} className="flex items-center gap-3" data-testid={`ai-step-${s.id}`}>
            <span className="flex shrink-0 -space-x-2">
              {s.avatars.map((a) => <img key={a} src={people[a].avatar} alt="" className="h-9 w-9 rounded-full border-2 border-white object-cover" />)}
            </span>
            <span className="text-[17px] font-semibold text-[#08090D]">{s.text}</span>
          </motion.li>
        ))}
      </ol>
      <div className="mt-10 grid grid-cols-2 gap-2.5 sm:grid-cols-3">
        {aiChips.map((c, i) => (
          <motion.div key={c.id} {...reveal(0.1 + i * 0.08)}>
            <AIChip chip={c} consent={consent} stacked />
          </motion.div>
        ))}
      </div>
      <motion.div {...reveal(0.2)} className="glass glass-heavy mx-auto mt-8 h-[160px] max-w-[300px] rounded-[30px] p-4" data-testid="ai-hub">
        <AIHubContent consent={consent} />
      </motion.div>
      <motion.div {...reveal(0.3)} className="mx-auto mt-10 max-w-[320px]">
        <AIRecommendationCard consent={consent} />
      </motion.div>
      <AIControls consent={consent} setConsent={setConsent} onReplay={() => setRun((r) => r + 1)} />
    </div>
  );
};
